<template>
  <div :class="classes" v-bind="$attrs">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import '../../styles/bonatitan/_global.scss'
import '../../styles/bonatitan/_variables.scss'
import '../../styles/bonatitan/u-text.scss'
import { computed } from 'vue'

const classes = computed(() => {
  return `u-text--description`
})
</script>
